import { store } from 'store';

import { reservationSlice } from 'api/endpoints/reservationSlice';

export const reserveMultiple = async (reservationsIdList: Array<string>, newValue: boolean) =>
  await Promise.all(
    reservationsIdList.map(async (reservationId) =>
      store.dispatch(
        reservationSlice.endpoints.reserveBebyggelseutkast.initiate(
          {
            id: reservationId,
            reserve: newValue
          },
          { fixedCacheKey: 'utkast-reservation' }
        )
      )
    )
  );
